import { render } from "./SimpleText.vue?vue&type=template&id=0a9e5108"
import script from "./SimpleText.vue?vue&type=script&lang=js"
export * from "./SimpleText.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__